import { render, staticRenderFns } from "./study_content1.vue?vue&type=template&id=87445be4&"
import script from "./study_content1.vue?vue&type=script&lang=js&"
export * from "./study_content1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports